import {upload_path} from "../../_AE/Helpers";

export const ROUTE = {
  prefix: "/admins"
}
export const context_title = {
  singular: "Admin",
  plural: "Admins",
}
export const images_path = upload_path+"/admins"


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    // enabled: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10
};

export const defaultEntity = {
  enabled: true,
};